import { render } from "./ReportsList.vue?vue&type=template&id=2dea593d"
import script from "./ReportsList.vue?vue&type=script&lang=js"
export * from "./ReportsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__